<h2 mat-dialog-title>
    {{'filters_add.title' | translate}}
</h2>

<mat-dialog-content class="dialog-content-pad-10">
    <form>
        <div class="form-group mb-3">
            <label class="col-form-label">{{'filters_add.name' | translate}}</label>
            <input id="filterNameInput"
                   type="text"
                   name="filterNameInput"
                   class="form-control"
                   [(ngModel)]="namedFilter.name"
                   required>
        </div>

        <div class="form-group">
            <label class="col-form-label">{{'filters_add.filter' | translate}}</label>
            <tm-filter-editor class="pe-5"
                              [filter]="namedFilter.decodedFilter"
                              [orgUnits]="availableOrgUnits"
                              (filterChange)="save_filters($event)">
            </tm-filter-editor>
        </div>

        <div class="form-group mb-3 row">
            <label class="col-form-label col-sm-auto">{{'filters_add.set_as_default' | translate }}</label>
            <div class="col-sm-2">
                <select class="form-select "
                        name="isDefault"
                        [(ngModel)]="namedFilter.default">
                    <option [ngValue]="namedFilter.default">{{'filter.default-' + namedFilter.default | translate}}</option>
                    <option [ngValue]="!namedFilter.default">{{'filter.default-' + !namedFilter.default | translate}}</option>
                </select>
            </div>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions class="justify-content-center">
    <button type="button"
            class="btn btn-default"
            (click)="cancel()">{{'cancel' | translate}}</button>

    <button type="button"
            class="btn btn-primary"
            [disabled]="!namedFilter.name || namedFilter.decodedFilter.predicates.length === 0"
            (click)="save(namedFilter)">
        @switch(mode) {
            @case('create'){
                <span>{{'filters_add.create' | translate}}</span>
            }
            @case('update'){
                <span>{{'update' | translate}}</span>
            }
        }
    </button>
</mat-dialog-actions>